module.exports = __webpack_public_path__ + "img/5.dde86fb9.jpg";